<template>

    <div class="canvas::editor-website-editors-input-LinkInput">
        <SwitchInput
            label="Interne pagina of invulveld?"
            instruction=""
            :options="options"
            options-property="linkTarget"
            :items="[
                                { value: 'websitePage', label: 'Interne pagina'},
                                { value: 'customLink', label: 'Link invulveld'},
                            ]"
            defaultValue="websitePage"
            :open="open"
        />

        <accordion-input :open="open">
            <template #label>

                <div class="font-medium text-gray-600">Pagina verwijzing</div>

            </template>
            <template #content>
                <div class="my-5" v-if="options.linkTarget === 'websitePage' || !options.linkTarget">

                    <div class="mb-1 text-gray-600 label2">Naar welke pagina verwijzen?</div>

                    <WebsitePageSelector
                        ref="websitePageSelector"
                        :value.sync="options.websitePageId"
                        @update:value="setWebsitePage"
                        language="nl"
                    />

                </div>

                <div class="my-5" v-else>

                    <div class="mb-1 text-gray-600 label2">Wat is het adres?</div>

                    <input
                        ref="url"
                        type="text"
                        class="w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 border-solid rounded-md shadow-sm focus:border-blue-300 focus:outline-none focus:shadow-outline-blue form-control form-input sm:leading-5 sm:text-sm"
                        placeholder="http://www."
                        v-model="options.url"
                    />

                    <small class="block mt-3 text-gray-500 text-muted">
                        Gebruik voor externe websites de volledige url, dus ook met http(s)://.
                    </small>

                </div>

                <div class="my-5">

                    <div class="mb-1 text-gray-600 label2">Openen op</div>

                    <select
                        ref="target"
                        class="w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 border-solid rounded-md shadow-sm focus:border-blue-300 focus:outline-none focus:shadow-outline-blue form-control form-input sm:leading-5 sm:text-sm"
                        placeholder="Openen op pagina"
                        v-model="options.target"
                    >
                        <option v-for="(label, target) in targets"
                                :key="target"
                                :value="target">{{ label }}
                        </option>
                    </select>

                </div>
            </template>
        </accordion-input>
    </div>

</template>

<script>

import AccordionInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/helpers/Input";
import SwitchInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";
import WebsitePageSelector from "@galaxy/modules/Website/resources/js/admin/WebsitePageSelector";

export default {

    components: {
        AccordionInput,
        WebsitePageSelector,
        SwitchInput
    },

    props: {
        accordion: {
            type: Boolean,
            default: true
        },

        options: {
            type: Object,
            required: true,
        },

        language: {
            type: String,
            default: 'nl'
        },

        open: {
            type: Boolean,
            default: true
        },
    },

    data() {
        return {
            targets: {
                '_self': 'Huidige pagina',
                '_blank': 'Nieuwe pagina',
            },
        };
    },

    created()
    {
        this.setLanguage();
    },

    methods: {

        setLanguage() {
            this.language = document.documentElement.lang;
        },

        setWebsitePage(value) {
            // Set
            this.$set(this.options, 'websitePageId', value);
        },

    },

}

</script>

<style lang="scss" scoped>

</style>
